import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import { ASSETS } from '../constants';

type ReferWinHeaderPillProps = {
  onClick: () => void;
};

const Pill = styled.button`
  appearance: none;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  height: ${Spacings.SPACING_10B};
  min-width: calc(${Spacings.SPACING_23B} + ${Spacings.SPACING_1B});
  margin-right: ${Spacings.SPACING_1B};
  padding: 0 ${Spacings.SPACING_3B} 0 ${Spacings.SPACING_2B};
  border: 2px solid var(--color-divider);
  border-radius: ${Spacings.SPACING_25B};
  background-color: transparent;
  background-image: linear-gradient(
    236.56deg,
    #ffffff 8.54%,
    #ffefbf 57.43%,
    #f6a801 93.28%
  );
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${Spacings.SPACING_1};
  line-height: 0;
  ${mediaQuery.uptoMobile} {
    margin-right: ${Spacings.SPACING_1B};
    min-width: calc(${Spacings.SPACING_22B} + ${Spacings.SPACING_2B});
    padding-right: ${Spacings.SPACING_2B};
  }
`;

const GiftWrap = styled.span`
  flex-shrink: 0;
  width: calc(${Spacings.SPACING_8B} + ${Spacings.SPACING_1B});
  height: calc(${Spacings.SPACING_8B} + ${Spacings.SPACING_1B});
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

const Gift = styled.img`
  width: 100%;
  height: 100%;
  max-width: calc(${Spacings.SPACING_8B} + ${Spacings.SPACING_1B});
  max-height: calc(${Spacings.SPACING_8B} + ${Spacings.SPACING_1B});
  object-fit: contain;
  pointer-events: none;
`;

const Copy = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-weight: ${Fonts.EXTRABOLD};
  font-size: ${Fonts.EXTRA_SMALL};
  line-height: ${Fonts.EXTRA_SMALL};
  letter-spacing: 0.2px;
  text-transform: uppercase;
  text-align: center;
`;

const ReferLine = styled.span`
  color: var(--color-i-violet-light-1);
  white-space: nowrap;
`;

const WinLine = styled.span`
  color: var(--color-i-blue-46);
  white-space: nowrap;
`;

const ReferWinHeaderPill = ({ onClick }: ReferWinHeaderPillProps) => (
  <Pill type="button" onClick={onClick} aria-label="Refer and win">
    <GiftWrap>
      <Gift src={ASSETS.headerGift} alt="" />
    </GiftWrap>
    <Copy>
      <ReferLine>Refer</ReferLine>
      <WinLine>& Win</WinLine>
    </Copy>
  </Pill>
);

export default ReferWinHeaderPill;
